import { Injectable, signal } from '@angular/core';

interface Employee {
  id: string;
  initials: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  currentEmployee = signal<Employee|null>(null);

  constructor() {
    this.setEmployee({
      id: '12',
      initials: '11',
      name: 'Mads Mikkelsen'
    })
  }

  setEmployee(employee: Employee) {
    let username = '';
    if (employee) {
      username = 'flexpos-' + (employee?.initials ?? '') + '-' + (employee?.name ?? 'unknown');
    }
    localStorage.setItem('employee_username', username)
    this.currentEmployee.set(employee);
  }

}
